import { gql } from "graphql-request";

export const ADMIN_ACCOUNT_DELETION_SURVEYS = gql`
  query AdminAccountDeletionSurveys($input: AdminAccountDeletionSurveysInputDto!) {
    adminAccountDeletionSurveys(input: $input) {
      items {
        surveyId
        userId
        userEmail
        userCreatedAt
        withdrawnAt
        reason
        detail
      }
      meta {
        totalCount
        totalPages
        currentPage
        limit
        hasNextPage
        hasPrevPage
      }
      reasonCounts {
        reason
        count
      }
    }
  }
`;
